import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7659b6e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "se-gallery" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "flex align-center justify-center grow",
  style: {"height":"100vh"}
}
const _hoisted_4 = { class: "gallery-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-pc",
  style: {"width":"60px"}
}, null, -1))
const _hoisted_6 = { class: "picture" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-pc",
  style: {"width":"60px"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_zoompinch = _resolveComponent("zoompinch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displayed != null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
          class: "overlay-div"
        }, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDisplayed && _ctx.closeDisplayed(...args))),
            class: "cross"
          }, "✖"),
          _createVNode(_component_zoompinch, {
            ref: "zoompinchRef",
            transform: _ctx.transform,
            width: 800,
            height: 800,
            offset: _ctx.offset,
            "min-scale": 1,
            "max-scale": 10,
            rotation: true,
            bounds: false,
            mouse: "",
            touch: "",
            wheel: "",
            gesture: ""
          }, {
            canvas: _withCtx(() => [
              _createElementVNode("img", { src: _ctx.displayed }, null, 8, _hoisted_2)
            ]),
            _: 1
          }, 8, ["transform", "offset"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
        class: "cross"
      }, "✖"),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pictures, (picture) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("img", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openImage && _ctx.openImage(...args))),
              style: {"width":"300px","height":"auto"},
              src: picture
            }, null, 8, _hoisted_7)
          ]))
        }), 256)),
        _hoisted_8
      ])
    ])
  ]))
}